import React, {useState} from "react";
import {Platform, View} from "react-native";
import Button from "../Button";
import {FormikProps} from "formik";
import {DesktopDatePicker} from '@mui/x-date-pickers/DesktopDatePicker';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {colors} from "../../assets/styles/colors";
import P from "../../lib/P";
import {isFullSwing} from "../../constants";
// import DateTimePickerModal from "react-native-modal-datetime-picker";
// import './DatePickerDarkTheme.css';

const darkTheme = createTheme({
  palette: {mode: 'dark'}, zIndex: {...createTheme().zIndex, modal: 99999},
  components: {MuiInputBase: {styleOverrides: {input: {'::placeholder': {color: 'rgb(229, 229, 231)', opacity: 1}}}}}
});

type Props = {
  formik: FormikProps<any>, mb?: string, label?: string, h?: string, w?: string, bg?: string, hideBorder?: boolean,
  rounded?: string, textAlign?: 'left' | 'center' | 'right', placeholder?: string, fs?: string, hideIcon?: boolean,
  variant: 'filled' | 'outlined'
};

const DateTimePicker = (props: Props) => {
  const {formik, mb, label, h, w, bg, rounded, textAlign, placeholder, fs, hideIcon, hideBorder, variant} = props;
  const [, setDatePickerVisibility] = useState(false);
  const iconStyle: any = {position: 'absolute', right: 30};
  if (hideIcon) iconStyle.display = 'none';

  return (
    <>
      {Platform.OS === 'web' ? (
        <>
          {label && <P fw="500" fs={12} ta="center" opacity={0.5} mb={3} tt="uppercase">{label}</P>}

          <ThemeProvider theme={darkTheme}>
            <DesktopDatePicker
              value={formik.values.dateOfBirth} onChange={(date) => formik.setFieldValue('dateOfBirth', date)}
              label={isFullSwing ? placeholder : ''}
              slotProps={{
                layout: {sx: {backgroundColor: colors.new_input_color}},
                textField: {placeholder: isFullSwing ? '' : placeholder || 'MM/DD/YYYY', variant}
              }}
              views={['year', 'month', 'day']} disableFuture
              sx={{
                height: h || 66, backgroundColor: 'transparent', marginBottom: mb, width: w || '100%',
                '.MuiInputBase-root': {
                  borderRadius: rounded || '200px', height: h || 'auto', width: w || '100%',
                  backgroundColor: bg || colors.loading_login, paddingRight: 0,
                  '&:before': {borderBottomColor: isFullSwing ? formik.touched.dateOfBirth && formik.errors.dateOfBirth ? 'rgb(255, 69, 58)' : 'transparent' : 'transparent'}
                },
                '.MuiFormLabel-root': {color: isFullSwing ? formik.touched.dateOfBirth && formik.errors.dateOfBirth ? 'rgb(255, 69, 58)' : 'rgba(255, 255, 255, 0.7)' : 'rgba(255, 255, 255, 0.7)'},
                '.MuiInputBase-input': {
                  textAlign: textAlign || 'center', fontFamily: 'Barlow-Medium', fontSize: fs || 24,
                  height: h || 'auto', width: w || '100%'
                },
                '.MuiOutlinedInput-notchedOutline': {
                  borderColor: `${colors[formik.touched.dateOfBirth && formik.errors.dateOfBirth ? 'newDangerText' : 'settings_border']} !important`,
                  borderWidth: hideBorder ? '0 !important' : '1px !important'
                },
                '.MuiInputAdornment-root': iconStyle
              }}
            />
          </ThemeProvider>
        </>
      ) : (
        <View>
          <Button
            text={formik.values.dateOfBirth ? formik.values.dateOfBirth.format('MM/DD/YYYY') : ''}
            onPress={() => setDatePickerVisibility(true)}
          />
          {/*<DateTimePickerModal*/}
          {/*  isVisible={isDatePickerVisible}*/}
          {/*  mode="date"*/}
          {/*  onConfirm={handleConfirm}*/}
          {/*  onCancel={() => setDatePickerVisibility(false)}*/}
          {/*/>*/}
        </View>
      )}
    </>
  );
};

export default React.memo(DateTimePicker);
